module.exports = __webpack_public_path__ + "static/media/diagnoseTypeSwaper.359867f4.svg";